<template>
  <v-list-item class="style-class-element" @click="setActive(item)">
    <v-list-item-action
      class="my-0 mx-0 pr-2"
      :class="{
        'style-class-element-img': true,
        'style-class-element-img-active': isActive,
      }"
    >
      <layer-style-preview-icon is-icon :layer-type="layerType" :layer-style="item" />
    </v-list-item-action>
    <v-list-item-content class="py-0 style-class-element-content">
      <v-list-item-title
        :class="{
          'style-class-title': true,
          'style-class-active': isActive,
        }"
      >
        {{ getStyleClassOthersValue(item) }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
import LayerStylePreviewIcon from '@/components/LayerStylePreviewIcon';
import stylePreviewUtilities from '@/mixins/stylePreviewUtilities';
export default {
  name: 'StyleDialogContentClass',
  mixins: [stylePreviewUtilities],
  components: { LayerStylePreviewIcon },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    layerType: {
      type: String,
      default: '',
    },
  },
  methods: {
    setActive(item) {
      this.$emit('setActive', item);
    },
  },
};
</script>
<style lang="scss" scoped>
.style-class-element {
  min-height: 30px !important;
}
.style-class-element-img {
  height: 24px;
  background-color: #e0e0e0;
  border-radius: 4px 0px 0px 4px;
  padding-left: 5px;
  cursor: pointer;
}
.style-class-element-img-active {
  background-color: rgba(158, 158, 158, 0.52);
}
.style-class-element-content {
  height: 24px;
  display: inline-block;
}
.style-class-title {
  text-align: left !important;
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 12px !important;
  padding-top: 4px;
  height: 24px;
  padding-right: 8px;
  float: left;
  background-color: #e0e0e0;
  border-radius: 0px 4px 4px 0px;
  cursor: pointer;
}
.style-class-active {
  background-color: rgba(158, 158, 158, 0.52);
  font-weight: bold !important;
}
</style>
